import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { PersonalSiteService } from './personal-site.service';
import { ExposedEnvironmentVariable } from '../../../environments/environment-variables';
import { EnvironmentVariablesService } from '../../core/services/environment-variable-service/environment-variables.service';
import { SEOService } from '../../core/services/seo-service/seo.service';
import { FindUserByNicknevResponseDto } from './personal-site.interfaces';
import { HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PartnerplusConstants } from '../../global/partnerplus.constants';
import { JsonLdService } from '../../shared/services/json-ld/json-ld.service';

@Injectable({
  providedIn: 'root',
})
export class PersonalSiteResolver implements Resolve<FindUserByNicknevResponseDto> {
  unregisteredUsers: FindUserByNicknevResponseDto[] = PartnerplusConstants;
  constructor(
    private personalSiteService: PersonalSiteService,
    @Inject(PLATFORM_ID) private platformId: object,
    private environmentVariablesService: EnvironmentVariablesService,
    private seoService: SEOService,
    private router: Router,
    private jsonLdService: JsonLdService
  ) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<FindUserByNicknevResponseDto> | Promise<FindUserByNicknevResponseDto> | FindUserByNicknevResponseDto {
    const nicknev = route.paramMap.get('username').trim().toLocaleLowerCase();
    return this.personalSiteService.findByNicknev({ nicknev }).pipe(
      tap(
        (response: FindUserByNicknevResponseDto) => {
          response.keycloakRealm === this.environmentVariablesService.getVar(ExposedEnvironmentVariable.KEYCLOAK_REALM)
            ? this.jsonLdService.addOrUpdateStructuredData(
                this.jsonLdService.generateVeaResellerShopStructuredData({ ...response, nicknev: nicknev })
              )
            : this.jsonLdService.addOrUpdateStructuredData(
                this.jsonLdService.generateFranchisePartnerStructuredData({ ...response, nicknev: nicknev })
              );
          this.setMetaTags({ ...response, nicknev: nicknev });
        },
        (e: HttpErrorResponse) => {
          this.router.navigate(['/404']);
        }
      )
    );
  }

  private setMetaTags(user: FindUserByNicknevResponseDto): void {
    this.seoService.updateTitle(user.nev);
    this.seoService.updateDescription(user.motto);
    this.seoService.updateMetaTag('og:title', user.nev);
    this.seoService.updateMetaTag('og:description', user.motto);
    this.seoService.updateMetaTag(
      'og:url',
      `${this.environmentVariablesService.getVar(ExposedEnvironmentVariable.NETFONE_URL)}/${user.nicknev}`
    );
    this.seoService.updateMetaTag('og:image', this.getImageSrc(user.ogImageName));
    this.seoService.updateMetaTag('og:image:type', 'image/jpeg');
    this.seoService.updateMetaTag('og:image:width', '1200');
    this.seoService.updateMetaTag('og:image:height', '630');
  }

  private getImageSrc(imageName: string): string {
    return `${this.environmentVariablesService.getVar(ExposedEnvironmentVariable.PROFILKEP_URL)}/${imageName}.jpg`;
  }
}
